<template>
  <vx-card no-shadow>
    <vs-input
      class="w-full mb-base"
      name="newPassword"
      label-placeholder="Nova Senha"
      v-model="newPassword"
      v-validate="'required'"
    />
    <vs-input
      class="w-full mb-base"
      name="confirmNewPassword"
      label-placeholder="Confirmar Nova Senha"
      v-model="confirmNewPassword"
      v-validate="'required'"
    />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button
        class="ml-auto mt-2"
        @click="updateUser()"
        :disabled="!isFormValid"
        >Salvar</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
export default {
  data() {
    return {
      newPassword: "",
      confirmNewPassword: "",
    };
  },
  computed: {
    isFormValid() {
      return (
        !this.errors.any() &&
        this.newPassword &&
        this.confirmNewPassword &&
        this.newPassword === this.confirmNewPassword
      );
    },
  },
  methods: {
    async updateUser() {
      const dontHaveErrors = !(await this.$validator.validateAll());
      if (dontHaveErrors) return;
      try {
        this.user = {
          idUser: this.$store.state.user.idUser,
          password1: this.newPassword,
          password2: this.confirmNewPassword,
        };
        this.$vs.loading();
        await axios.post(`${baseApiUrl}/user/updatePasswordUser`, this.user);
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        this.newPassword = "";
        this.confirmNewPassword = "";
      } catch (error) {
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Erro",
          text: `Não foi possivel salvar ` + error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
